module.exports = __webpack_public_path__ + "img/bio_photo.67bcee5f.jpg";